// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"170":"api-test","982":"product-detail"}[chunkId] || chunkId) + "." + {"170":"0b522b12","555":"abc97070","623":"ec2fd57a","982":"5db137a2"}[chunkId] + ".js";
};